/**
 * useHeroParallax — attaches a mousemove listener to a ref'd element and
 * writes `--mx` / `--my` CSS custom properties so styled children can drift
 * a few pixels with the cursor.
 *
 * The styled components in LandingPage.styled read `var(--mx)` / `var(--my)`
 * on the hero orbs to create the subtle parallax feel.
 */

import { useEffect, type RefObject } from 'react';

export function useHeroParallax(ref: RefObject<HTMLElement>) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const move = (e: MouseEvent) => {
      const { left, top, width, height } = el.getBoundingClientRect();
      el.style.setProperty('--mx', `${((e.clientX - left) / width - 0.5) * 20}px`);
      el.style.setProperty('--my', `${((e.clientY - top) / height - 0.5) * 20}px`);
    };
    el.addEventListener('mousemove', move);
    return () => el.removeEventListener('mousemove', move);
  }, [ref]);
}
